<template>
  <a-dialog ref="dialog" name="refresh_urls" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('content') }} <code>{{ this.ids.length }}</code> {{ $t('content-url') }}
    </div>
    <span slot="actions">
      <v-btn color="warning" text @click="submit">{{ $t('actions.analyze') }} {{ this.ids.length }} {{
          $t('url')
        }}</v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'RefreshUrlsDialog',
  data () {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened ({ ids }) {
      if (ids.length > 0) {
        this.ids = ids
      } else {
        this.ids = this.$services.urlMonitoring.urlMonitors.all.map(monitor => monitor.id)
      }
    },
    async submit () {
      this.loading = this.$t('planning')

      try {
        await this.$api.post('url-monitors/refresh', { ids: this.ids }, { notifyErrors: false })
        this.$ui.success(this.$t('success'))
        this.$bus.emit('url-monitoring/require_refresh')
        if (this.$refs.dialog) this.$refs.dialog.close()
      } catch (err) {
        if (err.exception === 'ThrottledRefreshUrlMonitorException') {
          this.$ui.error(this.$t('error'))
        }
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"content": "Would you like to perform a new analysis of",
		"content-url": "URL ? This operation may take several minutes.",
		"error": "Impossible to schedule the analysis, please wait at least one hour between each schedule.",
		"planning": "Planning the analysis",
		"success": "The analysis was scheduled successfully.",
		"title": "Analyze Now",
		"url": "URL"
	},
	"es": {
		"content": "¿Le gustaría realizar un nuevo análisis de",
		"content-url": "URL ? Esta operación puede tardar varios minutos.",
		"error": "No se puede programar el análisis, espere al menos una hora entre cada programa.",
		"planning": "Planificación del análisis",
		"success": "El análisis se programó correctamente.",
		"title": "Analizar ahora",
		"url": "URL"
	},
	"fr": {
		"content": "Souhaitez-vous effectuer une nouvelle analyse de",
		"content-url": "URL ? Cette opération peut prendre plusieurs minutes.",
		"error": "Impossible de programmer l'analyse, merci de patienter au moins une heure entre chaque programmation.",
		"planning": "Planification de l'analyse",
		"success": "L'analyse a été programmée avec succès.",
		"title": "Analyser maintenant",
		"url": "URL"
	},
	"it": {
		"content": "Desideri eseguire una nuova analisi di",
		"content-url": "URL ? Questa operazione potrebbe richiedere diversi minuti.",
		"error": "Impossibile pianificare l'analisi, attendi almeno un'ora tra ogni pianificazione.",
		"planning": "Pianificazione dell'analisi",
		"success": "L'analisi è stata pianificata con successo.",
		"title": "Analizza ora",
		"url": "URL"
	},
	"pt": {
		"content": "Gostaria de realizar uma nova análise de",
		"content-url": "URL ? Esta operação pode demorar vários minutos.",
		"error": "Impossível agendar a análise, aguarde pelo menos uma hora entre cada agendamento.",
		"planning": "A planear a análise",
		"success": "A análise foi agendada com sucesso.",
		"title": "Analisar agora",
		"url": "URL"
	},
	"pl": {
		"content": "Czy chcesz przeprowadzić nową analizę",
		"content-url": "URL ? Ta operacja może zająć kilka minut.",
		"error": "Nie można zaplanować analizy, poczekaj co najmniej godzinę między kolejnymi planowaniami.",
		"planning": "Planowanie analizy",
		"success": "Analiza została pomyślnie zaplanowana.",
		"title": "Analizuj teraz",
		"url": "URL"
	}
}
</i18n>

